import React from "react";
import  { useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/aboutHeroSection.css";
import AOS from "aos";
import "aos/dist/aos.css";
import HeroImage from "../assets/images/Hero Image/HeroImage.jpg"

const AboutHeroSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-out'
    });
  }, []);
  return (
    <section className="about-hero-section d-flex align-items-center text-white position-relative" id="home" >
      
      {/* Background Image with Overlay */}
      <div className="hero-bg">
        <img
          src={HeroImage}
          alt="Hero Background"
          className="hero-img"
        />
        <div className="hero-overlay"></div>
      </div>

      {/* Content */}
      <div className="container position-relative text-center text-md-start">
        <div className="row" data-aos="fade-right">
          <div className="col-lg-8 " data-aos="fade-right" data-aos-delay="100">
            <h1 className="display-5 fw-bold text-shadow">
              Transforming Spaces Through Perfect Climate Control
            </h1>
            <p className="fs-5 mb-4">
              Since 2015, we've been at the forefront of delivering innovative air conditioning solutions that create comfortable environments for businesses and homes alike.
            </p>

            {/* Buttons */}
            <div className="d-flex flex-wrap gap-3 justify-content-md-start justify-content-center" data-aos="fade-up" data-aos-delay="300">
              <a href="/services" className="btn btn-lg solution-btn">
                Explore Our Services
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <a href="#introduction">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
          <div className="arrow">
            <span></span>
          </div>
        </a>
      </div>
    </section>
  );
};

export default AboutHeroSection;
